import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { MovimentoResponseDTO, MovimentoCreateDTO } from '../../models/gerenciar-contas/movimento.model';
import { MovimentoDTO } from '../../models/gerenciar-contas/movimento.model';

@Injectable({
  providedIn: 'root',
})
export class MovimentoService {

  private movimentoCriadoSubject = new BehaviorSubject<MovimentoDTO | null>(null);
  public movimentoCriado$ = this.movimentoCriadoSubject.asObservable();
  constructor(private apiService: ApiService) { }

  get(url: string, data?: any): Observable<MovimentoResponseDTO> {
    const queryParams = this.apiService.buildQueryParams(data);
    const path = queryParams ? `${url}?${queryParams}` : url;
    return this.apiService.read<MovimentoResponseDTO>(path);
  }
  getById<T>(url: string): Observable<MovimentoDTO> {
    return this.apiService.read<MovimentoDTO>(url);
  }

  post<T>(url: string, data: MovimentoDTO): Observable<MovimentoDTO> {
    return this.apiService.create<MovimentoDTO>(url, data).pipe(
      tap((movimentoCriado: MovimentoDTO) => {
        this.movimentoCriadoSubject.next(movimentoCriado);
      })
    );
  }

  /** Criar movimento com vinculo a titulo (recebimento/pagamento de titulo) */
  criarMovimentoComTitulo(data: MovimentoCreateDTO): Observable<any> {
    return this.apiService.create<any>('/movimento', data);
  }

  put<T>(url: string, data: MovimentoDTO): Observable<MovimentoDTO> {
    return this.apiService.update<MovimentoDTO>(url, data);
  }

  delete<T>(url: string): Observable<any> {
    return this.apiService.delete(url);
  }
}
